import React from 'react';
import Footer from '../footer/Footer';
import Navigation from '../navigation/Navigation';

import '../../styles/main.scss';

export default function Layout(props) {
	return (
		<>
			<div className='layout'>
				<Navigation />
				<main>{props.children}</main>
			</div>
			<Footer />
		</>
	);
}
